import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { SvgGlyphs } from './Glyph.Glyphs.es.js';

const sizes = {
    /**
     * Base Size.
     */ base: '48',
    /**
     * Large Size.
     */ lg: '80'
};
const Glyph = ({ name, className, size = 'base', disabled, ...props })=>{
    const glyphName = name.toLowerCase();
    // Pick the glyph as a component
    const SvgGlyph = SvgGlyphs[name];
    // Combine class names
    const classes = classNames('cb-glyph', `cb-glyph-${glyphName}`, className, {
        'cursor-pointer': props.onClick,
        'pointer-events-none': !props.onClick || disabled
    });
    return jsx(SvgGlyph, {
        className: classes,
        height: sizes[size],
        width: sizes[size],
        ...props,
        "aria-hidden": !props.onClick,
        "data-testid": `glyph-${glyphName}`,
        focusable: false,
        role: "img"
    });
};

export { Glyph, Glyph as default };
//# sourceMappingURL=Glyph.es.js.map
